import React, { PureComponent } from 'react'
import OnFleetTeamInfoItem from './OnFleetTeamInfoItem'

class OnFleetTeamInfo extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectedPanel: 0,
    }
  }

  selectPanel = (selectedPanel) => () => {
    this.setState({
      selectedPanel,
    })
  }

  render() {
    const { selectedPanel } = this.state
    const { shopsList = {} } = this.props
    const { values = [] } = shopsList
    const shops = values || []

    return (
      <div>
        {shops.map((shop, index) => {
          if (shop.appTarget && shop.appTarget === 'Retail') {
            return (
              <OnFleetTeamInfoItem
                shop={shop}
                index={index}
                selectedPanel={selectedPanel}
                selectPanel={this.selectPanel}
              />
            )
          }
        }) || null}
      </div>
    )
  }
}

export default OnFleetTeamInfo



// WEBPACK FOOTER //
// ./src/components/OnFleet/OnFleetTeamInfo.js